<template>
    <div>
        <v-breadcrumbs :items="breadcrumbsItems" class="pa-0 mb-3" large></v-breadcrumbs>
        <div class="main-content mx-auto">
            <v-form ref="homeworkForm" v-model="valid" lazy-validation>
                <div class="mb-5">
                    <label class="font-weight-medium">{{ $t('edit.diary_name') }}</label>
                    <v-text-field v-model="nameInput" :label="$t('edit.diary_name_label')" outlined flat solo dense
                        hide-details="auto"
                        :rules="nameInputRules"></v-text-field>
                </div>
                <div class="mb-5">
                    <label class="font-weight-medium">{{ $t('edit.diary_description') }}</label>
                    <v-textarea v-model="descriptionInput" :label="$t('edit.diary_description_label')" outlined flat
                        solo
                        hide-details="auto"
                        :rules="descriptionInputRules"></v-textarea>
                </div>
                <!-- <div class="mb-5">
                    <label class="font-weight-medium">{{ $t('edit.select_grade') }}</label>
                    <v-row no-gutters>
                        <v-col cols="4" md="2" v-for="(item, ind) in gradeList" :key="`grade${ind}`">
                            <v-checkbox class="mt-0" v-model="gradeInput" :label="item.title" :value="item.value"
                                hide-details="auto" :rules="gradeInputRules"></v-checkbox>
                        </v-col>
                    </v-row>
                </div> -->

                <div class="mb-5">
                    <label class="font-weight-medium">{{ $t('edit.user_limit') }}</label><small>（{{
                        $t('user_charge_plan.ticket_remain_num') }}{{ ucpCount }} ）</small>
                    <v-text-field v-model="studentLimitInput" :label="$t('edit.user_limit')" outlined flat solo dense
                        hide-details="auto"
                        type="number"
                        :max="ucpCount"
                        :min="currentTookNumber"
                        :rules="studentLimitInputRules"></v-text-field>
                </div>

                <div class="mb-5">
                    <label class="font-weight-medium">{{ $t('edit.label_color') }}</label>
                    <v-item-group class="d-flex" mandatory v-model="colorInput">
                        <v-item class="mr-2" v-for="item in colorList" :key="item.value" :value="item.value"
                            v-slot="{ active, toggle }">
                            <v-card :color="item.code" class="d-flex align-center text-center" dark height="30"
                                width="30"
                                @click="toggle">
                                <v-scroll-y-transition>
                                    <v-icon v-if="active" class="mx-auto" label>mdi-check</v-icon>
                                </v-scroll-y-transition>
                            </v-card>
                        </v-item>
                    </v-item-group>
                </div>

                <div class="mb-5">
                    <label class="font-weight-medium">{{ $t('edit_pronunciation') }}</label>
                    <v-select :items="speechLangList" item-text="title" item-value="value" v-model="speechLangInput"
                        :label="$t('edit.lang.users_language')" outlined flat dense solo hide-details="auto"
                        :rules="speechLangInputRules"></v-select>
                </div>


                <!--
                    注音只對中文有意義（其他語言後端一律存 false）。
                    ⚠ 還要看 hasTemplate：沒選地圖建立的日記本沒有 template，沒有地方存這個設定。
                -->
                <div v-if="speechLangInput == 'zh' && hasTemplate" class="mb-5">
                    <v-checkbox class="mt-0 font-weight-medium" v-model="isNeedBpmf"
                        hide-details="auto" :label="$t('edit.bpmf_label')"></v-checkbox>
                    <div class="text-caption grey--text text--darken-1 mt-1">
                        {{ $t('edit.bpmf_hint') }}
                    </div>
                </div>

                <!--
                    學生自由撰寫時，題目與三個範例畫格從哪裡來。
                    ⚠ 只有關卡式日記本（hasTemplate）有這個設定——沒有 template
                    的日記本沒有自由撰寫的流程，設了也不會有作用。
                -->
                <div v-if="hasTemplate" class="mb-5">
                    <label class="font-weight-medium">{{ $t('edit.sample_mode.label') }}</label>
                    <v-radio-group class="mt-0" dense hide-details="auto" v-model="sampleMode">
                        <v-radio v-for="item in sampleModeList" :key="item.value" :label="item.title"
                            :value="item.value"
                            hide-details="auto"></v-radio>
                    </v-radio-group>
                    <div class="text-caption grey--text text--darken-1 mt-1">
                        {{ $t('edit.sample_mode.hint') }}
                    </div>
                </div>

                <div class="mb-5">
                    <label class="font-weight-medium">{{ $t('edit.expriation') }}</label>
                    <v-radio-group class="mt-0" dense hide-details="auto" v-model="diaryTimeTypeInput">
                        <v-radio v-for="item in diaryTimeTypeList" :key="item.value" :label="item.title"
                            :value="item.value"
                            hide-details="auto"></v-radio>
                    </v-radio-group>
                    <v-card class="mt-2 px-3 pt-5" outlined v-if="diaryTimeTypeInput == '2'">
                        <v-row>
                            <v-col>
                                <v-menu ref="datePickerMenu" v-model="datePickerMenu" :close-on-content-click="false"
                                    :return-value.sync="takeEndDateInput" transition="scale-transition" offset-y
                                    min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="takeEndDateInput" :label="$t('edit.select_date')"
                                            prepend-icon="mdi-calendar"
                                            readonly v-bind="attrs" v-on="on" dense
                                            :rules="takeEndDateInputRules"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="takeEndDateInput" :min="diaryTimeMinDate" no-title
                                        scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn class="normal-case" text color="primary" @click="datePickerMenu = false">
                                            {{ $t('button.cancel') }}
                                        </v-btn>
                                        <v-btn class="normal-case" text color="primary"
                                            @click="$refs.datePickerMenu.save(takeEndDateInput)">
                                            {{ $t('button.confirm') }}
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col>
                                <v-menu ref="timePickerMenu" v-model="timePickerMenu" :close-on-content-click="false"
                                    :nudge-right="40"
                                    :return-value.sync="takeEndTimeInput" transition="scale-transition" offset-y
                                    max-width="290px"
                                    min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="takeEndTimeInput" label="選擇時間"
                                            prepend-icon="mdi-clock-time-four-outline" readonly v-bind="attrs" v-on="on"
                                            dense :rules="takeEndTimeInputRules"></v-text-field>
                                    </template>
                                    <v-time-picker v-if="timePickerMenu" v-model="takeEndTimeInput" format="24hr">
                                        <v-spacer></v-spacer>
                                        <v-btn class="normal-case" text color="primary" @click="timePickerMenu = false">
                                            {{ $t('button.cancel') }}
                                        </v-btn>
                                        <v-btn class="normal-case" text color="primary"
                                            @click="$refs.timePickerMenu.save(takeEndTimeInput)">
                                            {{ $t('button.confirm') }}
                                        </v-btn>
                                    </v-time-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                    </v-card>
                </div>
                <div v-if="shareTypeAvailable" class="mb-5">
                    <label class="font-weight-medium">{{ $t('button.setting_apply') }}</label>
                    <v-radio-group class="mt-0" dense hide-details="auto" v-model="diaryShareTypeInput">
                        <v-radio v-for="item in diaryShareTypeList" :key="item.value" :label="item.title"
                            :value="item.value"
                            hide-details="auto"></v-radio>
                    </v-radio-group>
                </div>

                <div v-if="loginSetting && loginSetting.available" class="mb-5">
                    <label class="font-weight-medium">{{ $t('edit.login.title') }}</label>
                    <div v-if="loginSetting.locked" class="text-caption grey--text">{{ $t('edit.login.locked') }}</div>
                    <v-radio-group class="mt-0" dense hide-details="auto" v-model="loginRadioInput"
                        :disabled="loginSetting.locked">
                        <v-radio :label="$t('edit.login.mode_normal')" value="normal"></v-radio>
                        <v-row no-gutters class="ml-8" v-if="loginModeInput == 'normal'">
                            <v-col cols="6" sm="4" v-for="item in loginTypeList" :key="item.value">
                                <v-checkbox class="mt-0" v-model="loginTypesInput" :label="item.title"
                                    :value="item.value" :disabled="loginSetting.locked"
                                    hide-details="auto"></v-checkbox>
                            </v-col>
                            <v-col cols="6" sm="4" v-if="loginTypesInput.includes('email')">
                                <v-checkbox class="mt-0" :input-value="true" :label="$t('edit.login.email')"
                                    disabled hide-details="auto"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-radio class="mt-2" :label="$t('edit.login.guest')" value="guest"></v-radio>
                    </v-radio-group>
                    <div class="ml-8" v-if="loginRadioInput == 'guest'">
                        <v-checkbox class="mt-1" v-model="instantChecked" :label="$t('edit.login.instant')"
                            :hint="$t('edit.login.instant_hint')" persistent-hint
                            :disabled="loginSetting.locked"></v-checkbox>
                    </div>
                    <v-card class="mt-2 ml-8 px-3 pt-5" outlined v-if="loginModeInput == 'instant'">
                        <v-text-field v-model="instantPrefixInput" :label="$t('edit.login.instant_prefix')"
                            :hint="$t('edit.login.instant_prefix_hint')" persistent-hint outlined flat dense
                            :rules="instantPrefixInputRules" :disabled="loginSetting.locked"
                            class="mb-3"></v-text-field>
                        <v-text-field v-model="instantNameInput" :label="$t('edit.login.instant_name')"
                            :placeholder="$t('edit.login.guest')" :counter="instantNameMaxLength" outlined flat dense
                            :rules="instantNameInputRules" :disabled="loginSetting.locked"></v-text-field>
                    </v-card>
                </div>

                <div v-if="showQuestOnlyOptions">
                    <div class="mb-3">
                        <label class="font-weight-medium">{{ $t('edit.setting_calendar') }}</label>
                        <v-radio-group class="mt-0" dense hide-details="auto" v-model="diaryCalendarTypeInput">
                            <v-radio v-for="item in diaryCalendarTypeList" :key="item.value" :label="item.title"
                                :value="item.value"
                                hide-details="auto"></v-radio>
                        </v-radio-group>
                    </div>
                    <!-- <div class="mb-3">
                        <v-checkbox class="my-2 font-weight-medium" v-model="aiScoring" hide-details="auto"
                            :label="$t('edit.ai_scoring')" disabled></v-checkbox>
                    </div> -->
                </div>
                <div class="mb-5">
                    <label class="font-weight-medium">{{ $t('button.notification_setting') }}</label>
                    <div class="mb-1">
                        <v-checkbox class="mt-0" v-model="diaryNotificationSubmitInput"
                            :label="$t('edit.notify_submit')"
                            hide-details="auto"></v-checkbox>
                        <v-select :items="diaryNotificationSubmitList" item-text="title" item-value="value"
                            v-model="diaryNotificationSubmitTimeInput" :label="$t('edit.notify_time')" outlined flat
                            dense solo
                            hide-details="auto" :disabled="!diaryNotificationSubmitInput"
                            :rules="diaryNotificationSubmitTimeInputRules"></v-select>
                    </div>
                    <div class="mb-1">
                        <v-checkbox class="mt-0" v-model="diaryNotificationStatInput"
                            :label="$t('edit.notify_emotion_report')"
                            hide-details="auto"></v-checkbox>
                        <v-select :items="diaryNotificationStatList" item-text="title" item-value="value"
                            v-model="diaryNotificationStatTimeInput" :label="$t('edit.notify_time')" outlined flat dense
                            solo
                            hide-details="auto" :disabled="!diaryNotificationStatInput"
                            :rules="diaryNotificationStatTimeInputRules"></v-select>
                    </div>
                    <div class="mb-1">
                        <v-checkbox class="mt-0" v-model="diaryNotificationExtremeWordInput"
                            :label="$t('edit.notify_violence_detect')"
                            hide-details="auto" disabled></v-checkbox>
                        <v-select :items="diaryNotificationExtremeWordList" item-text="title" item-value="value"
                            v-model="diaryNotificationExtremeWordTimeInput" :label="$t('edit.notify_time')" outlined
                            flat dense solo
                            hide-details="auto" :disabled="!diaryNotificationExtremeWordInput"
                            :rules="diaryNotificationExtremeWordTimeInputRules"></v-select>
                    </div>
                </div>
            </v-form>
            <v-divider></v-divider>
            <div class="text-right mt-4">
                <v-btn v-if="homeworkId == ''" class="mr-2 normal-case" color="secondary" outlined large
                    @click="$router.go(-1)">
                    {{ $t('button.cancel') }}
                </v-btn>
                <v-btn v-else class="mr-2 normal-case" color="secondary" outlined large
                    @click="$router.push('/diary/homework/:id/info'.replace(':id', homeworkId))">
                    {{ $t('button.cancelAndBackToInfo') }}
                </v-btn>
                <v-btn class="normal-case" color="primary" large :loading="buttonLoading" :disabled="buttonLoading"
                    @click="saveHomework">{{
                        $t('button.save') }}
                </v-btn>
            </div>
        </div>
        <v-snackbar v-model="snackBar.on" :timeout="snackBar.timeout" :color="snackBar.type" right>
            {{ snackBar.text }}
        </v-snackbar>
        <v-overlay :value="dataLoading">
            <v-progress-circular
                color="amber darken-3"
                indeterminate
                height="8"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import { diaryServices } from '@/services/diary.js';
import { userPayServices } from '@/services/userPay.js';
import {
    parseSubType, mergeSubType,
    SUB_TYPE_CALENDAR, SUB_TYPE_AI_SAMPLE, SUB_TYPE_DEFAULT_SAMPLE,
} from '@/utils/subType.js';

/**
 * 寫作範例來源的三種選擇，對應 `sub_type` 的位元。
 *
 * ⚠ 學生端是 `ai_sample && !use_default_sample`，所以 5 與 10 同時存在時
 * 實際生效的是**預設範例**。做成 radio 而不是兩個 checkbox，就是為了讓老師
 * 沒辦法造出那個「看起來兩個都開、其實只有一個生效」的狀態。
 */
const SAMPLE_MODE_NONE = 'none';
const SAMPLE_MODE_AI = 'ai';
const SAMPLE_MODE_DEFAULT = 'default';

export default {
    name: "news",
    components: {},
    data() {
        return {
            snackBar: {
                on: false,
                text: "My timeout is set to 2000.",
                timeout: 2000,
                type: "info",
            },
            breadcrumbsItems: [],
            buttonLoading: false,
            dataLoading: false,
            homeworkId: '',
            nameInput: '',
            nameInputRules: [(v) => !!v || this.$t('general.msg.must_filled')],
            descriptionInput: '',
            descriptionInputRules: [],
            gradeInput: [],
            gradeInputRules: [() => this.gradeInput.length != 0 || this.$t('general.msg.must_filled')],
            gradeList: [
                {
                    title: this.$t('edit.grade.1'),
                    value: '1',
                }, {
                    title: this.$t('edit.grade.2'),
                    value: '2',
                }, {
                    title: this.$t('edit.grade.3'),
                    value: '3',
                }, {
                    title: this.$t('edit.grade.4'),
                    value: '4',
                }, {
                    title: this.$t('edit.grade.5'),
                    value: '5',
                }, {
                    title: this.$t('edit.grade.6'),
                    value: '6',
                }, {
                    title: this.$t('edit.grade.7'),
                    value: '7',
                }, {
                    title: this.$t('edit.grade.8'),
                    value: '8',
                }, {
                    title: this.$t('edit.grade.9'),
                    value: '9',
                }
            ],
            studentLimitInput: '',
            studentLimitInputRules: [
                (v) => !!v || this.$t('general.msg.must_filled'),
                (v) => v <= (this.ucpCount + this.currentPublishNumber) || this.$t('edit.rules.ucp_insufficent'),
                (v) => v >= 1 || `${this.$t('edit.rules.min_number')} 1`,
                (v) => v >= this.currentTookNumber || `${this.$t('edit.rules.took_number')} ${this.currentTookNumber}`,
            ],
            studentLimitList: [
                10, 20, 30, 40, 50, 60, 70, 80
            ],
            colorInput: '',
            colorList: [
                {
                    code: 'red',
                    value: '1',
                }, {
                    code: 'orange',
                    value: '2',
                }, {
                    code: 'yellow darken-1',
                    value: '3',
                }, {
                    code: 'green',
                    value: '4',
                }, {
                    code: 'blue',
                    value: '5',
                }, {
                    code: 'blue darken-4',
                    value: '6',
                }, {
                    code: 'deep-purple ',
                    value: '7',
                }
            ],
            speechLangInput: 'zh',
            isNeedBpmf: false,
            /// 只有有 template 的日記本才存得下注音設定（後端在 GetHomework 帶出來）
            hasTemplate: false,
            speechLangInputRules: [(v) => !!v || this.$t('general.msg.must_filled')],
            speechLangList: [
                // {
                //     title: this.$t('edit.lang.users_language'),
                //     value: 'user'
                // },
                {
                    title: this.$t('edit.lang.zh'),
                    value: 'zh'
                }, {
                    title: this.$t('edit.lang.en'),
                    value: 'en'
                }, {
                    title: this.$t('edit.lang.ja'),
                    value: 'ja'
                }
            ],
            diaryTimeTypeInput: '1',
            diaryTimeTypeList: [{
                title: this.$t('edit.expire_unlimit'),
                value: '1',
            }, {
                title: this.$t('edit.expire_at'),
                value: '2',
            }],
            diaryTimeMinDate: null,
            takeEndDateInput: '',
            takeEndDateInputRules: [(v) => (this.diaryTimeTypeInput == '2' && !!v) || this.$t('general.msg.must_filled')],
            takeEndTimeInput: '',
            takeEndTimeInputRules: [(v) => (this.diaryTimeTypeInput == '2' && !!v) || this.$t('general.msg.must_filled')],
            datePickerMenu: false,
            timePickerMenu: false,
            diaryShareTypeInput: '2',
            diaryShareTypeList: [{
                title: this.$t('edit.submit_auto'),
                value: '2',
            }, {
                title: this.$t('edit.submit_click'),
                value: '3',
            }],
            diaryNotificationSubmitInput: false,
            diaryNotificationSubmitTimeInput: null,
            diaryNotificationSubmitTimeInputRules: [(v) => ((this.diaryNotificationSubmitInput && v == null) ? this.$t('general.msg.must_filled') : true)],
            diaryNotificationSubmitList: [
                {
                    title: this.$t('edit.notify_at.immediately'),
                    value: '-1',
                }, {
                    title: this.$t('edit.notify_at.8'),
                    value: '8',
                }, {
                    title: this.$t('edit.notify_at.12'),
                    value: '12',
                }, {
                    title: this.$t('edit.notify_at.17'),
                    value: '17',
                }, {
                    title: this.$t('edit.notify_at.21'),
                    value: '21',
                }
            ],
            diaryNotificationStatInput: false,
            diaryNotificationStatTimeInput: null,
            diaryNotificationStatTimeInputRules: [(v) => ((this.diaryNotificationStatInput && v == null) ? this.$t('general.msg.must_filled') : true)],
            diaryNotificationStatList: [
                {
                    title: this.$t('edit.notify_at.8'),
                    value: '8',
                }, {
                    title: this.$t('edit.notify_at.12'),
                    value: '12',
                }, {
                    title: this.$t('edit.notify_at.17'),
                    value: '17',
                }, {
                    title: this.$t('edit.notify_at.21'),
                    value: '21',
                }
            ],
            diaryNotificationExtremeWordInput: false,
            diaryNotificationExtremeWordTimeInput: null,
            diaryNotificationExtremeWordTimeInputRules: [(v) => ((this.diaryNotificationExtremeWordInput && v == null) ? this.$t('general.msg.must_filled') : true)],
            diaryNotificationExtremeWordList: [
                {
                    title: this.$t('edit.notify_at.8'),
                    value: '8',
                }, {
                    title: this.$t('edit.notify_at.12'),
                    value: '12',
                }, {
                    title: this.$t('edit.notify_at.17'),
                    value: '17',
                }, {
                    title: this.$t('edit.notify_at.21'),
                    value: '21',
                }
            ],
            valid: false,
            diaryCalendarTypeInput: '0',
            diaryCalendarTypeList: [{
                title: this.$t('edit.calendar_mode.on'),
                value: '1',
            }, {
                title: this.$t('edit.calendar_mode.off'),
                value: '0',
            }],
            aiScoring: false,
            showQuestOnlyOptions: false,
            sampleMode: SAMPLE_MODE_NONE,
            sampleModeList: [{
                title: this.$t('edit.sample_mode.none'),
                value: SAMPLE_MODE_NONE,
            }, {
                title: this.$t('edit.sample_mode.ai'),
                value: SAMPLE_MODE_AI,
            }, {
                title: this.$t('edit.sample_mode.default'),
                value: SAMPLE_MODE_DEFAULT,
            }],
            subType: [],
            /// 載入時 sub_type 解析不出來就設 true，存檔時整個欄位不送。
            /// 見 utils/subType.js 的 parseSubType。
            subTypeUnreadable: false,
            shareTypeAvailable: true,
            currentPublishNumber: 0,
            currentTookNumber: 0,
            ucpCount: 0,
            defaultLang: 'zh',
            loginSetting: null,
            loginTypesInput: [],
            loginModeInput: 'normal',
            loginTypeList: [
                {
                    title: this.$t('edit.login.account'),
                    value: 'account',
                }, {
                    title: this.$t('edit.login.google'),
                    value: 'google',
                }, {
                    title: this.$t('edit.login.code'),
                    value: 'code',
                }
            ],
            instantPrefixInput: 'guest',
            instantPrefixInputRules: [(v) => (this.loginModeInput != 'instant' || /^[a-z]{1,8}$/.test(v || '')) || this.$t('edit.login.rule_prefix')],
            instantNameInput: '',
            instantNameMaxLength: 30,
            instantNameInputRules: [(v) => (v || '').trim().length <= this.instantNameMaxLength || this.$t('edit.login.rule_name')],
        };
    },
    async created() {
        this.dataLoading = true;
        this.homeworkId = this.$route.params.id;
        if (localStorage.getItem('locale') != 'zh') {
            this.defaultLang = 'en';
        }
        if (typeof this.homeworkId == 'undefined') {    
            this.homeworkId = null;
            this.speechLangInput = this.defaultLang;
        } else {
            const diaryHomeworkDetailRes = await diaryServices.getHomeworkDetail(this.homeworkId, {});
            const diaryHomeworkDetailData = diaryHomeworkDetailRes.data;
            this.nameInput = diaryHomeworkDetailData.name;
            this.descriptionInput = diaryHomeworkDetailData.description;
            this.colorInput = diaryHomeworkDetailData.diary_cover_color;
            diaryHomeworkDetailData.user_classes.forEach(userClass => {
                this.gradeInput.push(userClass);
            });
            this.studentLimitInput = diaryHomeworkDetailData.diary_publish_num;
            this.takeEndDateInput = diaryHomeworkDetailData.diary_take_end_date;
            //this.colorList = diaryHomeworkDetailData.label_color;

            if (diaryHomeworkDetailData.notification_submit_time != null) {
                this.diaryNotificationSubmitInput = true;
                this.diaryNotificationSubmitTimeInput = diaryHomeworkDetailData.notification_submit_time;
            }
            if (diaryHomeworkDetailData.notification_stat_time != null) {
                this.diaryNotificationStatInput = true;
                this.diaryNotificationStatTimeInput = diaryHomeworkDetailData.notification_stat_time;
            }
            if (diaryHomeworkDetailData.notification_extreme_word_time != null) {
                this.diaryNotificationExtremeWordInput = true;
                this.diaryNotificationExtremeWordTimeInput = diaryHomeworkDetailData.notification_extreme_word_time;
            }

            if (!diaryHomeworkDetailData.speech_lang) {
                this.speechLangInput = this.defaultLang;
            } else {
                this.speechLangInput = diaryHomeworkDetailData.speech_lang;
            }
            /// 有 template 才顯示注音選項。領取後的日記本拿不到整包 template，
            /// 後端在 GetHomework 另外帶了 has_template / is_need_bpmf。
            this.hasTemplate = diaryHomeworkDetailData.has_template === true
                || !!diaryHomeworkDetailData.template;
            this.isNeedBpmf = diaryHomeworkDetailData.is_need_bpmf === true
                || (diaryHomeworkDetailData.template || {}).is_need_bpmf === true;
            if (diaryHomeworkDetailData.share_type == '5') {
                this.shareTypeAvailable = false;
            }
            this.diaryShareTypeInput = diaryHomeworkDetailData.share_type;
            if (diaryHomeworkDetailData.sub_type) {
                const types = parseSubType(diaryHomeworkDetailData.sub_type);
                if (types === null) {
                    this.subTypeUnreadable = true;
                } else {
                    for (const subtype of types) {
                        switch (subtype) {
                            case 0:
                                this.diaryCalendarTypeInput = '1';
                                break;
                            case 2:
                                this.aiScoring = true;
                                break;
                        }
                    }
                    /// ⚠ 先看 10。學生端是 `ai_sample && !use_default_sample`，
                    /// 兩個都在時生效的是預設範例，畫面要顯示實際生效的那個。
                    if (types.indexOf(SUB_TYPE_DEFAULT_SAMPLE) !== -1) {
                        this.sampleMode = SAMPLE_MODE_DEFAULT;
                    } else if (types.indexOf(SUB_TYPE_AI_SAMPLE) !== -1) {
                        this.sampleMode = SAMPLE_MODE_AI;
                    }
                    this.subType = types;
                }
            }
            if (diaryHomeworkDetailData.share_type == '5') {
                this.showQuestOnlyOptions = true;
            }

            this.loginSetting = diaryHomeworkDetailData.login_setting || null;
            if (this.loginSetting && this.loginSetting.available) {
                this.loginModeInput = this.loginSetting.mode;
                // 一般模式才用得到勾選的登入方式；訪客、直達切回一般模式時用預設值
                this.loginTypesInput = this.loginSetting.mode == 'normal'
                    ? [...this.loginSetting.types] : ['account', 'google', 'code'];
                if (this.loginSetting.instant) {
                    this.instantPrefixInput = this.loginSetting.instant.prefix;
                    this.instantNameInput = this.loginSetting.instant.name || '';
                }
            }

            this.currentPublishNumber = diaryHomeworkDetailData.diary_publish_num;
            this.currentTookNumber = diaryHomeworkDetailData.diary_publish_num;
        }
        this.breadcrumbsItems.push(
            {
                text: this.$t('index.title'),
                disabled: false,
                href: `/diary`,
            });
        if (this.nameInput != '') {
            this.breadcrumbsItems.push({
                text: this.nameInput,
                disabled: false,
                href: `/diary/homework/${this.homeworkId}`,
            }, {
                text: this.$t('button.edit'),
                disabled: true,
                href: ``,
            })
        } else {
            this.breadcrumbsItems.push({
                text: this.$t('edit.diary_new'),
                disabled: true,
                href: ``,
            })
        }
        this.diaryTimeMinDate = new Date().toLocaleDateString('zh-TW', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '-');
        this.ucpCount = await userPayServices.getUnsoldUserChargePlanCount();
        this.dataLoading = false;
    },
    mounted() {
    },
    computed: {
        // 單選：一般登入 / 訪客；直達模式是訪客底下的勾選項
        loginRadioInput: {
            get() {
                return this.loginModeInput == 'normal' ? 'normal' : 'guest';
            },
            set(value) {
                this.loginModeInput = value;
            },
        },
        instantChecked: {
            get() {
                return this.loginModeInput == 'instant';
            },
            set(checked) {
                this.loginModeInput = checked ? 'instant' : 'guest';
            },
        },
    },
    watch: {

    },
    methods: {
        showAlertMsg(type, msg) {
            this.snackBar.type = type;
            this.snackBar.text = msg;
            this.snackBar.on = true;
        },
        // 只有可以設定、還沒鎖住的地圖主地圖才送 login
        buildLoginPayload() {
            if (!this.loginSetting || !this.loginSetting.available || this.loginSetting.locked) {
                return null;
            }
            // 直達模式與 studio 現有資料相同，只寫 instant、不寫 type
            if (this.loginModeInput == 'instant') {
                const instant = { prefix: this.instantPrefixInput };
                const name = (this.instantNameInput || '').trim();
                if (name) {
                    instant.name = name;
                }
                return JSON.stringify({ instant });
            }
            if (this.loginModeInput == 'guest') {
                return JSON.stringify({ type: ['guest'] });
            }
            const types = this.loginTypeList
                .map(item => item.value)
                .filter(value => this.loginTypesInput.includes(value));
            return JSON.stringify({ type: types });
        },
        async saveHomework() {
            const needLoginType = this.loginSetting && this.loginSetting.available && !this.loginSetting.locked;
            if (needLoginType && this.loginModeInput == 'normal'
                && !this.loginTypeList.some(item => this.loginTypesInput.includes(item.value))) {
                this.showAlertMsg('red', this.$t('edit.login.rule_required'));
                return;
            }
            if (this.$refs.homeworkForm.validate()) {
                /// 這一頁有權改寫的 sub_type 位元。
                ///
                /// ⚠⚠ 5/10 只在關卡式日記本上有 radio。非關卡式的畫面上看不到，
                /// 那時就**不能**列進 owned——否則存檔會把既有的 5 清掉，而且沒有
                /// 任何地方能改回來（stage 上就有一本 template 為 NULL 卻帶著 5 的
                /// 日記本）。2（英文 AI 評分）的 checkbox 是註解掉的，同樣不列。
                const ownedTypes = this.hasTemplate
                    ? [SUB_TYPE_CALENDAR, SUB_TYPE_AI_SAMPLE, SUB_TYPE_DEFAULT_SAMPLE]
                    : [SUB_TYPE_CALENDAR];
                const selected = [];
                if (this.diaryCalendarTypeInput != '0') {
                    selected.push(SUB_TYPE_CALENDAR);
                }
                if (this.hasTemplate) {
                    if (this.sampleMode === SAMPLE_MODE_AI) {
                        selected.push(SUB_TYPE_AI_SAMPLE);
                    } else if (this.sampleMode === SAMPLE_MODE_DEFAULT) {
                        selected.push(SUB_TYPE_DEFAULT_SAMPLE);
                    }
                }
                this.subType = mergeSubType(this.subType, ownedTypes, selected);
                let payload = {
                    name: this.nameInput,
                    description: this.descriptionInput,
                    diary_cover_color: this.colorInput,
                    user_classes: this.gradeInput.join(','),
                    diary_publish_num: this.studentLimitInput,
                    diary_take_end_date: `${this.takeEndDateInput} ${this.takeEndTimeInput}`.trim(),
                    label_color: this.colorInput,
                    notification_submit_time: this.diaryNotificationSubmitInput ? this.diaryNotificationSubmitTimeInput : null,
                    notification_stat_time: this.diaryNotificationStatInput ? this.diaryNotificationStatTimeInput : null,
                    notification_extreme_word_time: this.diaryNotificationExtremeWordInput ? this.diaryNotificationExtremeWordTimeInput : null,
                    speech_lang: this.speechLangInput == 'user' ? '' : this.speechLangInput,
                    /// 非中文一律送 false（後端也會再擋一次）
                    is_need_bpmf: this.speechLangInput == 'zh' && this.isNeedBpmf,
                    share_type: this.diaryShareTypeInput,
                }
                /// 後端對 falsy 的 sub_type 會跳過不寫，欄位原樣保留。
                /// 解析不出來時猜一個值寫回去，等於把不認得的旗標弄丟。
                if (!this.subTypeUnreadable) {
                    payload.sub_type = JSON.stringify(this.subType);
                }
                const login = this.buildLoginPayload();
                if (login != null) {
                    payload.login = login;
                }
                const res = await diaryServices.createHomework(this.homeworkId, payload);
                if (res.data.error == -2) {
                    this.showAlertMsg('red', this.$t('edit.login.save_error'));
                    return;
                }
                this.$router.push('/diary/homework/:id/news'.replace(':id', res.data.id));
            } else {
                this.showAlertMsg('red', this.$t('general.msg.input_incomplete'))
            }
        }
    },
}
</script>
<style scoped>
.main-content {
    max-width: 650px;
}
</style>
